/* eslint-disable @typescript-eslint/no-unused-vars */
import { Icon } from '@descomplica/foundation-ui-components';
import { observer, useViewModel } from '@descomplica/microfrontend-react';
import * as pdfMake from 'pdfmake/build/pdfmake';
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';

import {
  getMicroCertificateDocumentDefinition,
  pdfFonts,
  printPdf,
} from '@/application/utils/pdf-make/certificate-pdf.pdfmaker';
import { Button } from '@/presentation/shared-components/button/button';

import Loading from '../../components/loading';
import { CertificateViewModel } from './certificate.vm';

const Container = styled.div`
  width: 100%;
  font-family: 'Aprova Nova';
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: normal;
  color: #111;
  border-radius: 8px;
  position: relative;
  height: auto;
  overflow: auto;
`;

const TitleSection = styled.div`
  padding: 5rem 4rem 0 4rem;
  background-color: #fff;
  width: 100%;
`;

const ButtonContainer = styled.div`
  margin-bottom: 2rem;

  & button {
    margin-right: 1rem;
  }
`;

const ButtonCertificate = styled(Button)`
  margin-right: 1rem;
  padding: 0 4rem !important;
  text-align: center;
`;

const CertificateSectionTitle = styled.p`
  font-family: 'Aprova Nova';
  font-size: 56px;
  font-weight: 800;
  line-height: 64px;
  letter-spacing: -2.4px;
  text-align: left;
  display: flex;
  align-items: normal;
  margin-bottom: 2rem;
`;

const CertificateSection = styled.div`
  background-color: #cacdce;
  width: 100%;
  height: 80vh;
`;

const CertificatePreviewContainer = styled.div`
  height: 100%;
  width: 100%;
`;

const DownloadAnchor = styled(Link)`
  margin: unset;
  color: unset;
  display: flex;
  justify-content: space-between;

  & svg {
    margin-right: 0.5rem;
  }
`;

const ContainerLoading = styled.div`
  height: 100vh;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const Certificate: React.FC = () => {
  const vm = useViewModel(CertificateViewModel);
  const [url, setUrl] = useState('');
  const { guid } = useParams();

  useEffect(() => {
    const createCertificateURL = async (): Promise<void> => {
      if (guid) {
        await vm.handleScreenCertificate(guid);

        const buildCertificatePublicUrl = (guid: string) => {
          return location.protocol + '//' + location.hostname + `/certificate/public/${guid}`;
        };

        const certificatePublicUrl = buildCertificatePublicUrl(vm.certificate.guid);

        vm.setLinkedinUrl(certificatePublicUrl);

        const document = await getMicroCertificateDocumentDefinition(
          vm.certificate,
          buildCertificatePublicUrl(vm.certificate.guid),
        );
        pdfMake.createPdf(document, undefined, pdfFonts).getDataUrl((url) => {
          setUrl(url);
        });
      }
    };

    void createCertificateURL();
  }, [guid]);

  if (vm.isLoading) {
    return (
      <ContainerLoading>
        <Loading />
      </ContainerLoading>
    );
  }
  if (url) printPdf(url);

  return (
    <Container>
      <TitleSection>
        <CertificateSectionTitle>Parabéns pela conclusão do curso!</CertificateSectionTitle>
        <ButtonContainer>
          {vm.certificate && (
            <ButtonCertificate
              className="btn green"
              ariaLabel="Baixar certificado"
              onClick={() => {}}
            >
              <DownloadAnchor download={`Certificado - ${vm.certificate?.topicName}.pdf`} to={url}>
                <Icon name="download" />
                Download
              </DownloadAnchor>
            </ButtonCertificate>
          )}
          {vm.linkedinUrl && (
            <ButtonCertificate
              className="btn green"
              ariaLabel="Baixar certificado"
              onClick={() => {}}
            >
              <DownloadAnchor to={vm.linkedinUrl} target="_blank" rel="noopener noreferrer">
                <Icon name="share" />
                Compartilhar
              </DownloadAnchor>
            </ButtonCertificate>
          )}
        </ButtonContainer>
      </TitleSection>
      <CertificateSection>
        <CertificatePreviewContainer id="print" />
      </CertificateSection>
    </Container>
  );
};

export default observer(Certificate);
